<template>
  <div class="ranking">
    <h2 v-text="snippets.RankingBlock.title"></h2>
    <div class="ranking-table">
      <b-table
        :hoverable="true"
        :data="tableData"
        :columns="columns"
        :mobile-cards="false"
      >
        <template #empty>
          <div
            class="has-text-centered"
            v-text="snippets.RankingBlock.empty"
          ></div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "RankingBlock",
  data() {
    return {
      tableData: [],
    };
  },
  computed: {
    ...mapState(["snippets"]),
    columns() {
      return [
        {
          field: "rank",
          label: this.snippets.RankingBlock.column.rank,
          width: "30",
        },
        {
          field: "name",
          label: this.snippets.RankingBlock.column.name,
        },
        {
          field: "university",
          label: this.snippets.RankingBlock.column.university,
        },
        {
          field: "score",
          label: this.snippets.RankingBlock.column.score,
          width: "40",
        },
      ];
    },
  },
  created() {
    let teams = this.$store.getters.teams;
    let scoreRankings = new Array([]);
    let tableData = (teams ?? []).map((team) => {
      let scoreRaw = 0.0;
      if (team.scores) {
        scoreRaw = team.scores.reduce((current, entry) => {
          if ("0" === "" + entry.sub_contest) {
            current +=
              (entry?.bonus_points ?? 0.0) +
              (entry?.contest_points ?? 0.0) +
              (entry?.penalty_points ?? 0.0);
          }
          return current;
        }, 0.0);
      }
      let score = Math.trunc(+scoreRaw);
      if (scoreRankings.indexOf(score) === -1) {
        scoreRankings.push(score);
      }
      return {
        id: team.team,
        name: team.team_name,
        university: team.university,
        score: score, // (+score).toFixed(2),
        scoreRaw: scoreRaw,
      };
    });
    scoreRankings = Object.entries(scoreRankings.sort((a, b) => b - a)).reduce(
      (obj, [key, value]) => ({ ...obj, [value]: +key }),
      {}
    );
    tableData = tableData.sort((a, b) => b.scoreRaw - a.scoreRaw);
    tableData = tableData.map((entry, index0) => {
      entry.rank = 1 + index0;
      entry.rank = 1 + scoreRankings[entry.score];
      return entry;
    });
    this.tableData = tableData;
  },
};
</script>

<style>
@media screen and (max-width: 1023px) {
  .table-wrapper.table-wrapper {
    overflow-x: hidden;
  }
}
.ranking {
  margin: 3rem auto auto;
}
.ranking .b-table {
  margin: 1rem auto;
}

.ranking
  table:not([id^="wp-calendar"]):not(.ui-datepicker-calendar):not(.tribe-mini-calendar):not(.pika-table)
  th,
.ranking
  table:not([id^="wp-calendar"]):not(.ui-datepicker-calendar):not(.tribe-mini-calendar):not(.pika-table)
  td {
  text-align: left;
  font-size: 10px;
  padding: 0 8px;
}
.ranking
  table:not([id^="wp-calendar"]):not(.ui-datepicker-calendar):not(.tribe-mini-calendar):not(.pika-table)
  td[data-label="Score"] {
  text-align: right;
}

.ranking
  table:not([id^="wp-calendar"]):not(.ui-datepicker-calendar):not(.tribe-mini-calendar):not(.pika-table) {
  border-collapse: collapse;
}
.ranking
  table:not([id^="wp-calendar"]):not(.ui-datepicker-calendar):not(.tribe-mini-calendar):not(.pika-table)
  th
  span,
.ranking
  table:not([id^="wp-calendar"]):not(.ui-datepicker-calendar):not(.tribe-mini-calendar):not(.pika-table)
  td
  span {
  vertical-align: middle;
}
</style>
